import { Bean, BindingCreator, ValidationRules } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { StyledPractitionerName } from './PractitionerName.styled';

const MAX_PRACTITIONER_NAME_LENGTH = 100;
const VALIDATION_RULES: ValidationRules<Bean> = { required: true, maxLength: MAX_PRACTITIONER_NAME_LENGTH };

type PractitionerNameFieldName = 'diagnosedByName' | 'removalDiagnosisByName';
type PractitionerNameType = string | null;

export type PractitionerNameFormBeanPart = { [key in PractitionerNameFieldName]: PractitionerNameType };

type PractitionerNameProps<FIELD_NAME extends PractitionerNameFieldName> = {
   readonly register: BindingCreator<PractitionerNameFormBeanPart>;
   readonly name: FIELD_NAME;
   readonly label: string;
   readonly placeholder: string;
   readonly disabled?: boolean;
};

export const PractitionerName = <FIELD_NAME extends PractitionerNameFieldName>(
   props: PractitionerNameProps<FIELD_NAME>
): JSX.Element => {
   return (
      <StyledPractitionerName>
         <TextInput
            testId={props.name}
            controller={props.register(props.name, VALIDATION_RULES)}
            label={props.label}
            placeholder={props.placeholder}
            disabled={props.disabled}
         />
      </StyledPractitionerName>
   );
};
